"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@engaging-tech/components");
var _routing = require("@engaging-tech/routing");
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var Cart = function Cart() {
  var _useNavContext = (0, _useNavContext2["default"])(),
    cartData = _useNavContext.cartData;
  var router = (0, _routing.useRouter)();
  return /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    width: "fit-content",
    style: {
      cursor: "pointer"
    },
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    ml: 2,
    onClick: function onClick() {
      return router.navigate(cartData === null || cartData === void 0 ? void 0 : cartData.route);
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    bg: "primary.0",
    color: "light.0",
    fontSize: 5,
    borderRadius: "100%",
    width: 20,
    height: 20,
    left: 11,
    top: -1
  }, cartData === null || cartData === void 0 ? void 0 : cartData.items), /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    name: "shopping_cart",
    size: 40,
    color: "secondary.0"
  }), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    fontSize: 4,
    fontWeight: 600,
    color: "#707070"
  }, "Basket"));
};
var _default = exports["default"] = Cart;